import "../../App.scss";
import "../../assets/css/libraries.css";
import "../../assets/css/style.css";
import "../../assets/images/logo/logo-light-small.png";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import NavLogo from "../../assets/images/logo/NavLogo.png";
import NavLogoFooter from "../../assets/images/logo/NavLogoFooter_new.svg";
import Navbar from "../../components/Navbar/Navbar.jsx";
import RateCards from "./../../components/Landing/RateCards";

function Layout({ children, setSearchText, home }) {
  const [open, setOpen] = useState(0);
  const [search, setSearch] = useState("");

  const history = useHistory();

  return (
    <div className="wrapper">
      <Navbar />
      {children}

      <footer className="footer">
        <div className="footer-primary">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-3">
                <div className="footer-widget-about">
                  <img
                    src={NavLogoFooter}
                    alt="logo"
                    className="mb-30"
                    width="253px"
                    height="80px"
                  />
                  <p className="color-gray">
                    Our goal is to deliver quality of care in a courteous,
                    respectful, and compassionate manner. We hope you will allow
                    us to care for you and strive to be the first and best
                    choice for your family healthcare.
                  </p>
                  <a
                    href="appointment.html"
                    className="btn btn__primary btn__primary-style2 btn__link"
                  >
                    <span>Make Appointment</span>{" "}
                    <i className="icon-arrow-right"></i>
                  </a>
                </div>
                {/* <!-- /.footer-widget__content  --> */}
              </div>
              {/* <!-- /.col-xl-2  --> */}
              <div className="col-sm-6 col-md-6 col-lg-2 offset-lg-1">
                <div className="footer-widget-nav">
                  <h6 className="footer-widget__title">Our Services</h6>
                  <nav>
                    <ul className="list-unstyled">
                      <li>
                        <a href="#">For Doctors</a>
                      </li>
                      <li>
                        {" "}
                        <a href="/doctor/home" className="home-button">
                          Physicians
                        </a>
                      </li>
                      <li>
                        <a href="#">For Patients</a>
                      </li>
                      <li>
                        <a href="#">For Laboratories</a>
                      </li>
                      <li>
                        <a href="#">For Researchers</a>
                      </li>
                      <li>
                        <a href="#">For Trainers</a>
                      </li>
                    </ul>
                  </nav>
                </div>
                {/* <!-- /.footer-widget__content  --> */}
              </div>
              {/* <!-- /.col-lg-2  --> */}
              <div className="col-sm-6 col-md-6 col-lg-2">
                <div className="footer-widget-nav">
                  <h6 className="footer-widget__title">Links</h6>
                  <nav>
                    <ul className="list-unstyled">
                      <li>
                        <a href="#">About Us</a>
                      </li>
                      <li>
                        <a href="#">Our CLinic</a>
                      </li>
                      <li>
                        <a href="#">Our Doctors</a>
                      </li>
                      <li>
                        <a href="#">News & Media</a>
                      </li>
                      <li>
                        <a href="#">Appointments</a>
                      </li>
                    </ul>
                  </nav>
                </div>
                {/* <!-- /.footer-widget__content  --> */}
              </div>
              {/* <!-- /.col-lg-2  --> */}
              <div className="col-sm-12 col-md-6 col-lg-4">
                <div className="footer-widget-contact">
                  <h6 className="footer-widget__title color-heading">
                    Quick Contacts
                  </h6>
                  <ul className="contact-list list-unstyled">
                    <li>
                      If you have any questions or need help, feel free to
                      contact with our team.
                    </li>
                    <li>
                      <a href="tel:+91-9073940606" className="phone__number">
                        <i className="icon-phone"></i>{" "}
                        <span>+91-9073940606</span>
                      </a>
                    </li>
                    <li>
                      <a href="mailto:+91-9073940606" className="phone__number">
                        <i className="icon-email"></i>{" "}
                        <span>contactus@hlthtek.com</span>
                      </a>
                    </li>
                    <li className="color-body">Kolkata, West Bengal, India.</li>
                  </ul>
                  <div className="d-flex align-items-center">
                    <a href="#" className="btn btn__primary btn__link mr-30">
                      <i className="icon-arrow-right"></i>{" "}
                      <span>Get Directions</span>
                    </a>
                    <ul className="social-icons list-unstyled mb-0">
                      <li>
                        <a href="#">
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                    </ul>
                    {/* <!-- /.social-icons  --> */}
                  </div>
                </div>
                {/* <!-- /.footer-widget__content  --> */}
              </div>
              {/* <!-- /.col-lg-2  --> */}
            </div>
            {/* <!-- /.row  --> */}
          </div>
          {/* <!-- /.container  --> */}
        </div>
        {/* <!-- /.footer-primary  --> */}
        <div className="footer-secondary">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <span className="fz-14">
                  &copy; 2022 HlthTek Optimus Pvt. Ltd., All Rights Reserved.
                </span>
              </div>
              {/* <!-- /.col-lg-6  --> */}
              <div className="col-sm-12 col-md-6 col-lg-6">
                <nav>
                  <ul className="list-unstyled footer__copyright-links d-flex flex-wrap justify-content-end mb-0">
                    <li>
                      <a href="#">Terms & Conditions</a>
                    </li>
                    <li>
                      <a href="#">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="#">Cookies</a>
                    </li>
                  </ul>
                </nav>
              </div>
              {/* <!-- /.col-lg-6  --> */}
            </div>
            {/* <!-- /.row  --> */}
          </div>
          {/* <!-- /.container  --> */}
        </div>
        {/* <!-- /.footer-secondary  --> */}
      </footer>
      {/* <!-- /.Footer  --> */}
      <button id="scrollTopBtn">
        <i className="fas fa-long-arrow-alt-up"></i>
      </button>

      <Helmet>
        <script src="/assets/js/jquery-3.5.1.min.js"></script>
        <script src="/assets/js/plugins.js"></script>
        <script src="/assets/js/main.js"></script>
        <script
          src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"
          type="text/javascript"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&family=Roboto:wght@400;700&display=swap"
        />
        <link
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v5.15.3/css/all.css"
        />

        <link href="/assets/images/logo/logo-light-small.png" rel="icon" />
      </Helmet>
    </div>
  );
}
export default Layout;
